import { render, staticRenderFns } from "./GroupAttributes.vue?vue&type=template&id=9a0fe288&"
import script from "./GroupAttributes.vue?vue&type=script&lang=js&"
export * from "./GroupAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports